module.exports = __webpack_public_path__ + "img/logo4.86ec6e52.png";